import { HTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'
import Heading from '../Heading'
import { CloseIcon32 } from '../../icons'

interface DialogHeaderProps extends HTMLAttributes<HTMLElement> {
  title: string
  onClose?: () => void
  'data-testid': string
}

export default function DialogHeader({
  title,
  onClose,
  'data-testid': testId
}: Readonly<DialogHeaderProps>) {
  const { t } = useTranslation('ui-common')

  return (
    <header
      className="flex justify-between items-center py-0.5 px-2"
      data-testid={testId}
    >
      <Heading tag="h2" className="my-0 flex-1 text-center">
        {title}
      </Heading>
      {onClose && (
        <button
          type="button"
          className="absolute top-0 right-0 mt-[22px] mr-1.5 text-xl font-bold"
          title={t('dialog.close_button_aria_label')}
          aria-label={t('dialog.close_button_aria_label')}
          onClick={onClose}
          data-testid={`${testId}-close-button`}
        >
          <CloseIcon32
            className="shrink-0"
            data-testid={`${testId}-close-button-icon`}
          />
        </button>
      )}
    </header>
  )
}
